export const CSV_DELIMITER = {
  COMMA: ',',
  TAB: '\t',
} as const

const NEWLINE = '\r\n'

const needsQuoting = (value: string, delimiter: string): boolean =>
  value.includes(delimiter) ||
  value.includes('"') ||
  value.includes('\r') ||
  value.includes('\n')

const escapeCell = (value: string, delimiter: string): string =>
  needsQuoting(value, delimiter) ? `"${value.replace(/"/g, '""')}"` : value

export const serializeCsvRows = (rows: string[][], delimiter: string): string =>
  rows
    .map((row) =>
      row.map((cell) => escapeCell(cell, delimiter)).join(delimiter),
    )
    .join(NEWLINE)
